import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useTranslation } from 'react-i18next';

export default function Giris() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [mod, setMod] = useState('giris');
  const [email, setEmail] = useState('');
  const [sifre, setSifre] = useState('');
  const [isim, setIsim] = useState('');
  const [yukluyor, setYukluyor] = useState(false);
  const [hata, setHata] = useState('');
  const [mesaj, setMesaj] = useState('');

  async function handleGiris(e) {
    e.preventDefault();
    setHata('');
    setYukluyor(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password: sifre });
    if (error) {
      setHata(t('auth.wrongCredentials'));
    } else {
      navigate('/');
    }
    setYukluyor(false);
  }

  async function handleKayit(e) {
    e.preventDefault();
    setHata('');
    setYukluyor(true);
    const { error } = await supabase.auth.signUp({
      email,
      password: sifre,
      options: { data: { display_name: isim } }
    });
    if (error) {
      setHata(error.message === 'User already registered'
        ? t('auth.alreadyRegistered')
        : t('auth.registerError'));
    } else {
      setMesaj(t('auth.registerSuccess'));
      setMod('giris');
      supabase.functions.invoke('mail-gonder', {
        body: {
          tip: 'hosgeldin',
          to: email,
          data: { AD: isim || email.split('@')[0] },
        },
      }).catch(() => {});
    }
    setYukluyor(false);
  }

  async function handleGoogleGiris() {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: typeof window.AndroidBridge !== 'undefined'
          ? 'https://remil.app/auth/callback?app=1'
          : window.location.origin
      }
    });
  }

  const stil = {
    sayfa: {
      minHeight: '100vh',
      background: 'radial-gradient(ellipse at center, #1a0533 0%, #0a0015 100%)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '20px', fontFamily: 'Trebuchet MS, sans-serif', color: '#fff'
    },
    logo: { fontSize: '2.5rem', fontFamily: 'Georgia, serif', color: '#c084fc', marginBottom: '8px', textShadow: '0 0 20px #9333ea' },
    altYazi: { color: '#a78bfa', marginBottom: '32px', fontSize: '0.9rem' },
    kart: { background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(147,51,234,0.3)', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '380px', backdropFilter: 'blur(10px)' },
    input: { width: '100%', padding: '12px 16px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(147,51,234,0.3)', borderRadius: '10px', color: '#fff', fontSize: '1rem', marginBottom: '12px', outline: 'none', boxSizing: 'border-box' },
    buton: { width: '100%', padding: '14px', background: 'linear-gradient(135deg, #7c3aed, #9333ea)', border: 'none', borderRadius: '10px', color: '#fff', fontSize: '1rem', fontWeight: 'bold', cursor: 'pointer', marginTop: '8px', opacity: yukluyor ? 0.7 : 1 },
    googleButon: { width: '100%', padding: '12px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '10px', color: '#fff', fontSize: '0.95rem', cursor: 'pointer', marginTop: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' },
    gecis: { textAlign: 'center', marginTop: '20px', color: '#a78bfa', fontSize: '0.9rem', cursor: 'pointer' },
    hata: { background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.4)', borderRadius: '8px', padding: '10px 14px', color: '#fca5a5', fontSize: '0.85rem', marginBottom: '12px' },
    mesaj: { background: 'rgba(34,197,94,0.15)', border: '1px solid rgba(34,197,94,0.4)', borderRadius: '8px', padding: '10px 14px', color: '#86efac', fontSize: '0.85rem', marginBottom: '12px' }
  };

  return (
    <div style={stil.sayfa}>
      <div style={stil.logo}>🔮 Remil</div>
      <div style={stil.altYazi}>{t('auth.tagline')}</div>

      <div style={stil.kart}>
        <div style={{ display: 'flex', marginBottom: '24px', background: 'rgba(0,0,0,0.3)', borderRadius: '10px', padding: '4px' }}>
          {['giris', 'kayit'].map(m => (
            <button
              key={m}
              onClick={() => { setMod(m); setHata(''); setMesaj(''); }}
              style={{
                flex: 1, padding: '8px', border: 'none', borderRadius: '8px', cursor: 'pointer',
                background: mod === m ? 'linear-gradient(135deg, #7c3aed, #9333ea)' : 'transparent',
                color: '#fff', fontWeight: mod === m ? 'bold' : 'normal', fontSize: '0.9rem'
              }}
            >
              {m === 'giris' ? t('auth.login') : t('auth.register')}
            </button>
          ))}
        </div>

        {hata && <div style={stil.hata}>⚠️ {hata}</div>}
        {mesaj && <div style={stil.mesaj}>✅ {mesaj}</div>}

        <form onSubmit={mod === 'giris' ? handleGiris : handleKayit}>
          {mod === 'kayit' && (
            <input style={stil.input} type="text" placeholder={t('auth.namePlaceholder')} value={isim} onChange={e => setIsim(e.target.value)} required />
          )}
          <input style={stil.input} type="email" placeholder={t('auth.emailPlaceholder')} value={email} onChange={e => setEmail(e.target.value)} required />
          <input style={stil.input} type="password" placeholder={t('auth.passwordPlaceholder')} value={sifre} onChange={e => setSifre(e.target.value)} required minLength={6} />
          <button style={stil.buton} type="submit" disabled={yukluyor}>
            {yukluyor ? t('auth.loading') : mod === 'giris' ? t('auth.login') : t('auth.register')}
          </button>
        </form>

        <button style={stil.googleButon} onClick={handleGoogleGiris}>
          <span style={{ fontSize: '1.1rem' }}>G</span> {t('auth.googleLogin')}
        </button>

        <div style={stil.gecis} onClick={() => { setMod(mod === 'giris' ? 'kayit' : 'giris'); setHata(''); setMesaj(''); }}>
          {mod === 'giris' ? t('auth.noAccount') : t('auth.hasAccount')}
        </div>
      </div>
    </div>
  );
}